var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},_vm._l((_vm.moduleInfo.slice(0, 2)),function(item,index){return _c('div',{key:'_' + index,staticClass:"module-item"},[_c('div',{staticClass:"link"},[_c('el-image',{staticClass:"img",attrs:{"src":require('@/assets/img/' + item.img)}})],1),_c('p',[_vm._v(_vm._s(_vm.$t(item.desc)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }